"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.databaseConfig = void 0;
const databaseConfig = () => {
    const sslEnabled = process.env.DB_SSL === 'true';
    return {
        type: 'mysql',
        host: process.env.DB_HOST || 'localhost',
        port: parseInt(process.env.DB_PORT || '3306', 10),
        username: process.env.DB_USER || 'root',
        password: process.env.DB_PASS || '',
        database: process.env.DB_NAME || 'ayurcrm',
        autoLoadEntities: true,
        synchronize: process.env.NODE_ENV !== 'production',
        logging: process.env.NODE_ENV === 'development',
        charset: 'utf8mb4',
        timezone: '+05:30',
        // TiDB Serverless (and any TLS-required host) — enable with DB_SSL=true
        ...(sslEnabled && {
            ssl: {
                rejectUnauthorized: true, // verify server certificate (TiDB uses a trusted public CA)
                // If your provider requires a custom CA cert, set DB_SSL_CA env var:
                ...(process.env.DB_SSL_CA && { ca: process.env.DB_SSL_CA }),
            },
            // TiDB Serverless requires these extra driver options
            extra: {
                ssl: {
                    rejectUnauthorized: true,
                    ...(process.env.DB_SSL_CA && { ca: process.env.DB_SSL_CA }),
                },
            },
        }),
    };
};
exports.databaseConfig = databaseConfig;
